import styled from 'styled-components';
import { Tabs as RTTabs } from 'react-tabs';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';

export const Tabs = styled(RTTabs)<MarginProps>(margin);
